@if(Form) {
<div class="authForm-wrapper">
  <h3>{{ "Sign Up" | translate }}</h3>

  @if(!otpSent) {
  <p>{{ "Check your" | translate }} {{ usernameType }} {{ "to get 4 digit OTP pin to complete signup" | translate }}</p>
  <form [formGroup]="Form" (ngSubmit)="sendOtp()" class="form custom-scrollbar">
    <mat-form-field appearance="outline" class="username-fld full-width">
      <mat-label>{{ "First Name" | translate }}</mat-label>
      <input matInput placeholder="{{ 'Enter first name' | translate }}" type="text" formControlName="firstName" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ "Last Name" | translate }}</mat-label>
      <input matInput placeholder="{{ 'Enter last name' | translate }}" type="text" formControlName="lastName" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="username-fld full-width">
      <mat-label>{{ "Mobile No" | translate }}</mat-label>
      <input matInput placeholder="{{ 'Enter mobile number' | translate }}" type="text"
        formControlName="mobileNumber" />
      @if(Form.get('mobileNumber')?.value.length > 0) {
      <span matPrefix class="numPrefix">{{ "+1" | translate }}</span>
      }
      <mat-icon matSuffix>call</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ "Enter your Email Address" | translate }}</mat-label>
      <input matInput type="email" formControlName="emailId" autocomplete="off" required />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ "Set password" | translate }}</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" autocomplete="new-password" />
      <button mat-icon-button matSuffix type="button" (click)="hide = !hide">
        <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
      </button>
    </mat-form-field>

    <div class="terms">
      <mat-checkbox formControlName="terms" color="primary"> </mat-checkbox>
      {{ "I have read and accept the" | translate }}
      <a [routerLink]="['/terms']" target="_blank">{{ "Terms and Conditions" | translate }}</a>
    </div>

    <button mat-flat-button class="btn full-width" [disabled]="!Form.valid || loading">
      <span [class.vHidden]="loading">{{ "Signup" | translate }}</span>
      @if(loading) {
      <mat-spinner color="primary" diameter="20"></mat-spinner>
      }
    </button>
  </form>
  }

  @if(otpSent) {
  <div class="form-container">
    <p>{{ "Check your Mobile or Email to get 4 digit OTP pin for register." | translate }}</p>
    <form [formGroup]="VerifySignupForm" (ngSubmit)="onVerifySignup()">
      <app-otp-field (otpSubmit)="getOtp($event)"></app-otp-field>
      <button mat-flat-button class="full-width" color="primary" [disabled]="!VerifySignupForm.valid || loading">
        <span [class.vHidden]="loading">{{ "Complete Signup" | translate }}</span>
        <mat-spinner color="primary" *ngIf="loading" diameter="20"></mat-spinner>
      </button>
      <div class="secondary-action">
        {{ "Didn’t receive code?" | translate }}
        <a class="accent" (click)="sendOtp()">{{ "Request Again" | translate }}</a>
      </div>
    </form>
  </div>
  }
</div>
}